/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PatchedProviderNote } from '../models/PatchedProviderNote';
import type { ProviderNote } from '../models/ProviderNote';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ProviderNoteService {

    /**
     * Edit / delete one staff note on a provider (list + create live on
     * `/api/providers/{id}/notes/`). Provider notes are internal: every non-staff
     * context fails closed.
     * @returns ProviderNote
     * @throws ApiError
     */
    public static providerNoteUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this provider note.
         */
        id: string,
        requestBody: ProviderNote,
    }): CancelablePromise<ProviderNote> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/provider-note/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Edit / delete one staff note on a provider (list + create live on
     * `/api/providers/{id}/notes/`). Provider notes are internal: every non-staff
     * context fails closed.
     * @returns ProviderNote
     * @throws ApiError
     */
    public static providerNotePartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this provider note.
         */
        id: string,
        requestBody?: PatchedProviderNote,
    }): CancelablePromise<ProviderNote> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/provider-note/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Edit / delete one staff note on a provider (list + create live on
     * `/api/providers/{id}/notes/`). Provider notes are internal: every non-staff
     * context fails closed.
     * @returns void
     * @throws ApiError
     */
    public static providerNoteDestroy({
        id,
    }: {
        /**
         * A UUID string identifying this provider note.
         */
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/provider-note/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
